export const configStatisticProspectToday = [
  {
    name: "namaSalesmanCS",
    label: "Nama Salesman/CS",
    options: {
      sort: false,
    },
  },
  { name: "nonFU", label: "NON FU", options: { sort: false } },
  { name: "ongoing", label: "ONGOING", options: { sort: false } },
  { name: "pending", label: "PENDING", options: { sort: false } },
];

export const configReportAppointmentToday = [
  { name: "namaSalesmanCS", label: "Nama Salesman/CS", options: { sort: false } },
  { name: "namaKonsumen", label: "Nama Konsumen", options: { sort: false } },
  { name: "alamat", label: "Alamat", options: { sort: false } },
  { name: "kecamatan", label: "Kecamatan", options: { sort: false } },
  { name: "noHape1", label: "No Hape 1", options: { sort: false } },
  { name: "noHape2", label: "No Hape 2", options: { sort: false } },
];

export const configReportAppointmentOverdue = [
  ...configReportAppointmentToday,
  { name: "overdue", label: "Overdue", options: { sort: false } },
];